// Max duration of a test, in minutes: the limit of the legacy TESTDUREE SMALLINT, same as the backend
// CreateTestRequestDto::MAX_DURATION.
export const DURATION_MAX_MINUTES = 32767;

const isBlank = (value) => value == null || String(value).trim() === '';

// Native react-hook-form rules of the duration field, shared by the test page and the creation panel: a blank value is
// skipped by react-hook-form, so the duration stays optional.
export const durationRules = (message) => ({
    pattern: { value: /^\d+$/, message },
    min: { value: 1, message },
    max: { value: DURATION_MAX_MINUTES, message },
});

// Duration sent to the API: null when the field is blank, else its number of minutes.
export const toDurationPayload = (value) => (isBlank(value) ? null : Number(String(value).trim()));
